export const CREATE_TENANT = `
mutation createTenant (
    $tenant_id: Int!
    $input: CreateTenantInput!
    $file: Upload
){
  createTenant (
    tenant_id: $tenant_id
    input: $input
    file: $file
  ) {
    __typename
    ...on Tenant{
      id
      name
      slug
      active
      chair_account {
        id
        status
        chair_id
      }
      exhibitor_account {
        id
        status
        exhibitor_id
      }  
      city
      country
      invoice_identification_type_id
      invoice_identification
      invoice_company_name
    }
    ...on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const DELETE_TENANT = `
mutation deleteTenants($tenant_id: Int!, $ids: [Int!]!) {
  deleteTenants(tenant_id: $tenant_id, ids: $ids) {
    __typename
    ... on Count {
      count
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const UPDATE_TENANT = `
mutation updateTenant (
  $tenant_id: Int!, 
  $id: Int!, 
  $input: UpdateTenantInput!, 
  $file: Upload) {
  updateTenant(
    tenant_id: $tenant_id, 
    id: $id, 
    input: $input, 
    file: $file) {
    __typename
    ... on Tenant {
      id
      name
      slug
      active
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const CREATE_TENANT_PUBLIC = `
mutation createTenantPublic($input: CreateTenantPublicInput!, $turnstileToken: String!){
  createTenantPublic(input:$input, turnstileToken:$turnstileToken){
    ...on StringResult{
      result
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const RESEND_EMAIL_CREATE_PUBLIC = `
mutation resendEmailCreatePublic(
  $turnstileToken: String!,
  $input: ResendInvitationCreatePublicInput!
){
  resendEmailCreatePublic(
    turnstileToken:$turnstileToken,
    input:$input
  ){
    __typename
    ...on StringResult{
      result
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
